module.exports = __webpack_public_path__ + "img/s.6a317322.png";